
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConsoleTranscriptEntry } from './types';
import WebsiteSearchResults from './WebsiteSearchResults.vue';
import WebsiteDetailResult from './WebsiteDetailResult.vue';
import WebsiteActivityResult from './WebsiteActivityResult.vue';
import WebsiteHealthResult from './WebsiteHealthResult.vue';
import WebsiteDnsResult from './WebsiteDnsResult.vue';
import WebsiteSslResult from './WebsiteSslResult.vue';
import WebsiteLogsResult from './WebsiteLogsResult.vue';
import ConsoleActionPanel from './ConsoleActionPanel.vue';

@Component({
  components: {
    WebsiteSearchResults,
    WebsiteDetailResult,
    WebsiteActivityResult,
    WebsiteHealthResult,
    WebsiteDnsResult,
    WebsiteSslResult,
    WebsiteLogsResult,
    ConsoleActionPanel,
  },
})
export default class TranscriptEntry extends Vue {
  @Prop({ type: Object, required: true })
  public entry!: ConsoleTranscriptEntry;

  @Prop({ type: Boolean, default: false })
  public loadingMore!: boolean;

  public get isError(): boolean {
    return !!(this.entry.result && this.entry.result.kind === 'error');
  }

  public get isAction(): boolean {
    return !!(this.entry.result && this.entry.result.kind === 'action');
  }

  public get kindLabel(): string {
    if (this.entry.loading) {
      return 'running';
    }
    if (!this.entry.result) {
      return '';
    }
    const kind = this.entry.result.kind;
    if (kind === 'action') {
      return this.entry.result.actionId || 'action';
    }
    if (kind === 'empty') {
      return 'empty';
    }
    if (kind === 'choices') {
      return 'pick';
    }
    return kind;
  }

  public onChoiceCommand(command: string): void {
    const result = this.entry.result;
    if (!result || result.kind !== 'choices') {
      this.$emit('run-command', command);
      return;
    }

    const match = command.match(/^\/(site|activity|open|find|use|health|dns|ssl|logs)\s+(.+)$/);
    if (!match) {
      this.$emit('run-command', command);
      return;
    }

    const verb = match[1];
    const target = match[2];
    if (verb === 'site' || verb === 'open' || verb === 'find') {
      const intended = String(result.intendedCommand || 'site').split(/\s+/)[0];
      this.$emit('run-command', `/${intended} ${target}`);
      return;
    }
    this.$emit('run-command', command);
  }
}
